import { useSelector, useDispatch } from 'react-redux'
import { addMaterial, deleteMaterial } from '../../../../reducers/programBuilderReducer'
import { isFeatureEnabled } from '../../../../utility/featureEnablement'
import { GOLF_CLUBS_MATERIAL_NAME } from '../../../../utility/materials'

import FieldError from '../../../common/FieldError'
import MaterialCard from '../../../materials/MaterialCard'

const MaterialSelect = () => {
  const dispatch = useDispatch()

  const current_user = useSelector(state => state.user.current_user)
  const community = current_user.communities[0]
  const errors = useSelector(state => state.programBuilder.errors)
  const communityMaterials = useSelector(state => state.programBuilder.communityMaterials)
  const materials = useSelector(state => state.programBuilder.materials)

  const enabledMaterials = communityMaterials.filter(material => {
    if (material.name.includes('Starter Kit')) {
      return isFeatureEnabled(community, 'starter_kit')
    }
    if (material.name === GOLF_CLUBS_MATERIAL_NAME) {
      return isFeatureEnabled(community, 'golf_clubs')
    }
    return false
  })

  const handleMaterialsChange = (material, isSelected) => {
    dispatch(isSelected ? deleteMaterial(material) : addMaterial(material))
  }

  return (
    <div id='MaterialSelect' className='mt-3'>
      {enabledMaterials.map((material) => (
        <MaterialCard
          key={material.id}
          className='mb-3 font-size-14'
          material={material}
          isSelected={materials?.some(m => m.id === material.id)}
          handleCourseMaterialsChange={handleMaterialsChange}
          classEditor
        />
      ))}
      {errors.materialsIds && <FieldError message={errors.materialsIds} /> }
    </div>
  )
}

export default MaterialSelect
